export class AnalysisMessages {
  public titleAnalyse = 'analysis.title_analyse';
  public titleSignature = 'analysis.title_signature';
  public wait = 'analysis.wait';

  constructor() {
  }
}
